
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { AvtalCommandBase } from "./AvtalCommandBase";

export class CreateAvtalCommand extends AvtalCommandBase {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateAvtalCommand";

    constructor(avtalGuid: string) {
        super(avtalGuid, CreateAvtalCommand.$type, CommandType.Insert);
    }
}
